import React, { useContext } from 'react';
import { format } from 'date-fns';
import _ from 'lodash';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';

import Icon from '../../../Icon/Icon';
import formatOdds from '../../../../utils/formatOdds';
import '../NumberBet.scss';
import NumberBetContext from '../Context/NumberBet.context';
import useIsMobile from 'src/hooks/useIsMobile';

interface NumberBetProps {
  scrollable?: boolean,
  maxHeight?: number,
}

function QuickBet({
  scrollable,
  maxHeight
}: NumberBetProps) {
  const {
    date,
    selectedOddsType,
    singleBet
  } = useContext(NumberBetContext);
  const mobile = useIsMobile();

  const bet = singleBet;
  const { t } = useTranslation();

  const bonusIndex =
  _.findIndex(bet.selectedNumbers, { type: 'ball' }) > -1
    ? _.findIndex(bet.selectedNumbers, { type: 'bonus' })
    : -1;

  return (
    <>
      <div className="number-bet__icon" />
      <small className="number-bet__tournament">{ `${ bet.tournamentName },  ${ bet.country }` }</small>
      <div className={
        classNames({
          'number-bet__tournament-info': true,
          'number-bet__tournament-info--quickBet-desktop': !mobile
        })
      }
      >
        <small className={
          classNames({
            'number-bet__tournament-name number-bet__tournament-name--quick-bet': true,
            'number-bet__tournament-name--quickBet-desktop':  !mobile
          })
        }
        >
          { `${ format(date, 'HH:mm') }, ${ t('betslip.draw') }` }
        </small>
        <strong className="number-bet__odds number-bet__odds--quick-bet" >{ formatOdds(bet.odds, selectedOddsType) }</strong>
      </div>
      <div className={
        classNames({
          'number-bet__tournament-info': true,
          'number-bet__tournament-info--quickBet-desktop': !mobile
        })
      }
      >
        <small className="number-bet__place number-bet__place--quick-bet">
          { format(date, 'dd/MM') }
        </small>
      </div>
      <span className="number-bet__market">{ bet.marketName }</span>
      <div className="number-bet__number-container number-bet__number-container--quick-bet" >
        {
          bet.outcome && <span className={
            classNames({
              'number-bet__special-outcome number-bet__special-outcome--quick-bet': true,
              'number-bet__special-outcome--quickBet-desktop': !mobile
            })
          }
          >{ bet.outcome }</span>
        }

        {
          (bet.permutationsCount > 1 || bet.repetitionsCount > 1) &&(
            <div className={
              classNames({
                'number-bet__combinations-warning number-bet__combinations-warning--quick-bet': true,
                'number-bet__combinations-warning--quickBet-desktop': !isMobileOnly
              })
            }
            >{ t('betslip.combo') }</div>
          )
        }
        <div
          className={
            classNames({
              'number-bet__balls number-bet__balls--regular number-bet__balls--quick-bet': true,
              'number-bet__balls--scrollable': scrollable
            })
          }
          style={ maxHeight > 0 ? { maxHeight: maxHeight } : { maxHeight:'unset' } }
        >
          {
            _.map(bet.selectedNumbers, (number, value) => {
              if (number.type === 'ball' || bet.sameBallSet) {
                return (
                  <React.Fragment key={ value }>
                    <div
                      key={ value }
                      className={
                        classNames({
                          'number-bet__ball': true,
                          'number-bet__ball--betslip': true,
                          'number-bet__ball--quick-bet': true,
                          [`number-bet__ball--${ number.color.toLowerCase() }`]: number.color,
                          'number-bet__ball--selected': true,
                          'number-bet__ball--banker': number.isBanker,
                          'number-bet__ball--quickBet-desktop': !isMobileOnly
                        })
                      }
                    >
                      { number.number }
                    </div>
                    {
                      +value + 1 === bonusIndex && (
                        <Icon className="number-bet__plus number-bet__plus--quick-bet" icon="more" />
                      )
                    }
                  </React.Fragment>
                );
              } else {
                return (
                  <div
                    className={
                      classNames({
                        'number-bet__star number-bet__star--selected': true,
                        'number-bet__star--banker': number.isBanker
                      })
                    }
                    key={ value }
                  >
                    <div className="number-bet__star-value">{ number.number }</div>
                    <Icon icon="star" />
                  </div>
                );
              }
            })
          }
        </div>
      </div>
    </>
  );
}

export default QuickBet;
